import { createEvent, createStore, sample } from 'effector/compat'

export const addErrorMessage = createEvent<string>()
export const deleteErrorMessage = createEvent()
export const $errorMessage = createStore<string | null>(null)

sample({
    clock: addErrorMessage,
    target: $errorMessage
})

sample({
    clock: deleteErrorMessage,
    fn: () => null,
    target: $errorMessage
})
